/*
 * Built with Common Launchpad 4.0.2
 */

import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';

class Layout {
	constructor() {
		this.$body = $('body');
		this.$header = $('.header');
		this.$hiddenHeader = $('.js-top-target');

		this.$nav = $('.nav-wrapper');
		this.$primaryNavItem = $('.primary-nav > li');
		this.$primaryNavItemLink = $('.primary-nav > li > a');
		this.$searchToggle = $('.js-search-toggle');
		this.$searchMobileToggle = $('.nav-mobile-search.js-search-toggle');
		this.$searchDesktopToggle = $('.menu-item-search.js-search-toggle');
        this.$navToggle = $('.js-nav-toggle');
        this.$navToggleLabel = $('.js-nav-toggle-label');
		this.$navToggleChildren = $('.js-nav-toggle-children');
		this.$bannerClose = $('.js-banner-close');

		this.$headerSearchTextbox = $('.js-search-textbox');

		this.didScroll = false;
		this.lastScrollTop = 0;
		this.delta = 5;

		this.$footerAccordionItem = $('.js-footer-accordion > .footer-column-navigation-item--parent > a');

        this.timer = 0;

        this.$menuButton = $('.js-menu-icon');
        this.$menuIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="bars" class="svg-inline--fa fa-bars fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"/></svg>';
        this.$closeIcon = '<svg aria-hidden="true" data-prefix="far" data-icon="times" class="svg-inline--fa fa-times fa-w-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"/></svg>';
		this.previousViewport = Util.getViewPort();
	}

    init() {
		this.bindEvents();
		this.bindResizeEvent();
		//this.updateHeroMargin();
	}

	bindResizeEvent() {
		$(window).on('resize', () => {
			const currentViewport = Util.getViewPort();
			const isDesktop = currentViewport === CONST.ViewPort.Desktop;
			// If the viewport has changed between Desktop and Mobile, close search and menu
			if (currentViewport !== this.previousViewport) {
				this.closeSearchFormAndMenu();
				this.previousViewport = currentViewport; // Update the tracked viewport
			}

			//this.updateHeroMargin();
		});
	}

	bindEvents() {
		this.$navToggle.on('click.nav', e => { e.preventDefault(); this.toggleNav(e); });
		this.$navToggleChildren.on('click.nav', e => { this.mobileNavItem(e); });
		this.$searchToggle.on('click.nav', e => { this.toggleSearch(e); });
		this.$bannerClose.on('click.nav', e => {
			this.closeSearchFormAndMenu();
			//setTimeout(() => this.updateHeroMargin(), 300);
		});
		this.$primaryNavItemLink.on('keydown.nav', e => { this.tabbingNav(e); });
		this.$footerAccordionItem.on('click.footer', e => { e.preventDefault(); this.footerAccordion(e); });

		// Open megamenu on hover for desktop
		this.$primaryNavItem.on('mouseover.nav', e => {
			const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
			const searchForm = isDesktop ? $('.menu-search-desktop') : $('.menu-search-mobile');

			if (isDesktop) {
				clearTimeout(this.timer);
				$('.js-nav-megamenu').removeClass('open');
				this.openSubmenu(e);
			}
		}).on('mouseleave.nav', e => {
			const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
			const searchForm = isDesktop ? $('.menu-search-desktop') : $('.menu-search-mobile');

			if (isDesktop) {
				this.timer = setTimeout(() => this.closeSubmenu(e), 300);
			}
		});

		// Hide header and search form on scroll
		$(window).on('scroll.nav', () => {
			this.didScroll = true;
			this.closeSearchFormAndMenu();
		});

		// Close search form with ESC key on desktop
		$(document).on('keydown.nav', event => {
			if (event.key === 'Escape') {
				this.closeSearchFormAndMenu();
			}
		});

		// Close search form on tap outside for mobile
		$(document).on('click.touchstart.nav', event => {
			const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
			const searchContainer = $('.search.search-mobile');

			if (!isDesktop && !$(event.target).closest(searchContainer).length && !$(event.target).hasClass('js-search-mobile') && $('.menu-search-mobile').hasClass('focused')) {
				this.closeSearchFormAndMenu();
			}
		});

		// Smooth scroll to top on focus
		this.$hiddenHeader.on('keydown', e => {
           this.first_header = $('#main h1').first();
            if ((e.originalEvent.keyCode || e.keyCode) === 13 || (e.originalEvent.keyCode || e.keyCode) === 32) {
               this.first_header.attr('tabindex', '0');
               this.first_header.focus();
               window.scroll({
                top: this.first_header.offset().top - $('header').first().outerHeight(true),
                left: 0,
                behavior: 'smooth'
            });
           }
        });
	}

	updateHeroMargin() {
		const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
		const pbHero = $('.pb_area.pb_area-herocontent');
		if (!isDesktop) {
			const headerHeight = $('.header').outerHeight();
			pbHero.css('margin-top', `${headerHeight}px`);
		} else {
			pbHero.css('margin-top', 0);
		}
	}

	closeSearchFormAndMenu() {
		const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
		const searchForm = isDesktop ? $('.menu-search-desktop') : $('.menu-search-mobile');
		const headerHeight = $('.header').outerHeight();
	
		if (isDesktop) {
			this.$searchDesktopToggle.removeClass('open');
			this.$nav.css('top', 0);
		} else {
			this.$searchMobileToggle.removeClass('open');
			this.$nav.css('top', `${headerHeight}px`);
			this.$nav.slideUp().removeClass('open');
			this.$body.removeClass('nav-open');
		}

		searchForm.addClass('closed').removeClass('focused');

		$('.js-nav-megamenu').removeClass('open');
		$('.js-nav-toggle').removeClass('open');
	}


	closeSubmenu(e) {
		const target = $(e.currentTarget);
		$(target).closest('li').find('.js-nav-megamenu').removeClass('open');
	}

	toggleSearch(e) {
		const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
		const searchForm = isDesktop ? $('.menu-search-desktop') : $('.menu-search-mobile');
		const inputForm = isDesktop ? $('.search-desktop #header-search') : $('.search-mobile #header-search');
		const headerHeight = $('.header').outerHeight();

		searchForm.toggleClass('closed focused');
		searchForm.css('top', `${headerHeight}px`); 
		
		if (isDesktop) {
			this.$searchDesktopToggle.toggleClass('open');
		} else {
			this.$searchMobileToggle.toggleClass('open');
		}

		if (searchForm.hasClass('focused')) {
			// Fix for iOS: delay the focus slightly to ensure it applies
			setTimeout(() => {
				inputForm.focus();
			}, 300); // Small delay to ensure focus happens after the element is visible
		}

		if (!isDesktop && $('.js-nav-toggle').hasClass('open')) {
			$('.js-nav-toggle').removeClass('open');

			this.$nav.slideUp().removeClass('open');
			this.$body.removeClass('nav-open');
		}
	}

	// clicking on items in mobile nav
	mobileNavItem(e) {
		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
			e.preventDefault();
			const target = $(e.currentTarget);
			const parent = target.closest('li');
			$(parent).find('> ul').slideToggle();
			$(parent).find('> ul').toggleClass('open');
			$(parent).toggleClass('open');
		}
	}

	openSubmenu(e) {
		const target = $(e.currentTarget);
		$(target).closest('li').find('.js-nav-megamenu').addClass('open');
	}

	// if user hits enter when tabbing on menu items, open mega menu and set tabbing to children
	tabbingNav(e) {
		let target = $(e.currentTarget);

		if (e.keyCode === 13 && target.hasClass('has-dropdown')) {
			e.preventDefault();
			target.closest('li').addClass('focused');
			target.closest('li').find('.js-nav-megamenu').addClass('open');
		}

		let $activeElem = $(document.activeElement);
		let $prevItem = $activeElem.closest('li').prev();

		if ($prevItem.hasClass('focused')) {
			$prevItem.removeClass('focused');
			$prevItem.find('.js-nav-megamenu').removeClass('open');
		}

		if (e.shiftKey && (e.keyCode === 9)) {
			$('.js-nav-megamenu').removeClass('open');
		}
	}

	// Toggle nav on mobile
	toggleNav(e) {
		const headerHeight = $('.header').outerHeight();

		$('.js-nav-megamenu').removeAttr('style').closest('li').removeClass('open'); 
		$('.js-nav-toggle').toggleClass('open');

		this.$nav.slideToggle().toggleClass('open');
		this.$body.toggleClass('nav-open');
		this.$nav.css('top', `${headerHeight}px`); 

		this.closeMobileSearch(e);
	}

	closeMobileSearch(e) {
		const isDesktop = Util.getViewPort() === CONST.ViewPort.Desktop;
		const searchForm = $('.menu-search-mobile');

		if (!searchForm.hasClass('closed') && !isDesktop) {
			searchForm.addClass('closed').removeClass('focused');
			this.$searchMobileToggle.toggleClass('open');
		}
	}

    // Footer accordion expand/collapse
    footerAccordion(e) {
        const target = $(e.currentTarget);

		if (Util.getViewPort() !== CONST.ViewPort.Desktop) {
            target.parent().toggleClass('open');
			target.siblings('.footer-column-navigation-sub').slideToggle();
        }
		else {
			let href = $(target).attr('href');
			window.location = href;
		}        
    }
}

export default Layout;